export enum FlashMessageType {
  Success = 'success',
  Error = 'error',
  Plain = 'plain',
  Warning = 'warning',
  Info = 'info'
}

export enum ToastMessageType {
  Success = 'success',
  Error = 'error',
  Plain = 'message',
  Warning = 'warning',
  Info = 'info'
}

export enum MessageType {
  Success = 'success',
  Error = 'error',
  Message = 'message',
  Warning = 'warning',
  Info = 'info'
}
